import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { ProductInventoryInfo } from '../../models/Product';

function ProductPriceInfo(props: {
    onCancel: () => void,
    inventory: ProductInventoryInfo,
    isOpen: boolean
}) {
    return <>
        {<Modal isOpen={props.isOpen} toggle={props.onCancel} size="md" className="modal-dialog-centered">
            <div className="modal-header" style={{ display: 'inline-block' }}>
                <h5 className="modal-title">Sell Prices</h5>
                <h5 className="text-center">{props.inventory.ProductNumber}</h5>
                <button type="button" className="close" aria-label="Close" onClick={() => { props.onCancel() }}><span aria-hidden="true"><i className="fa fa-times"></i></span></button>
            </div>
            <ModalBody>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="d-flex flex-row">
                            <div className="p-1 col-sm-6"><span className="label-header">IMPACT PARTNER</span></div>
                            <div className="p-1 col-sm-6 text-right"><span className="label-header">SELLING AT</span></div>
                        </div>
                    </div>
                    {props.inventory.PartnerPrices.map((pp, i) => {
                        return (<div className="col-sm-12" key={i}>
                            <div className="d-flex flex-row">
                                <div className="p-1 col-sm-6"><span className="label-text">{pp.PartnerName}</span></div>
                                <div className="p-1 col-sm-6 text-right">
                                    {(pp.Price != null && pp.Price.toString() === "0") && <span className="label-value">$--.--</span>}
                                    {(pp.Price != null && pp.Price.toString() !== "0") && <span className="label-value">{new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD',
                                        minimumFractionDigits: 2,
                                    }).format(pp.Price)}</span>}
                                </div>
                            </div>
                        </div>);
                    })}
                </div>
            </ModalBody>
        </Modal>}
    </>
}

export default ProductPriceInfo;